import { FileText, Mail } from "lucide-react";
import { formatDateTime } from "../../utils/applicationFormatters";
import styles from "../../styles/applicationDetail.module.css";
import type { NoteLogRow } from "../../types/tabs";
import type { NotesTabSmsHistorySectionProps } from "../../types";

export function NotesTabSmsHistorySection({ tab }: NotesTabSmsHistorySectionProps) {
  const { smsLogsList } = tab;

  return (
    <div className={styles.section} data-testid="application-notes-tab-section-sms-history">
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>
          <span className={styles.sectionTitleIcon} aria-hidden="true">
            <FileText className="h-4 w-4" />
          </span>
          SMS History
        </h2>
      </div>
      <div className={styles.tableResponsive}>
        <table
          className={`${styles.table} ${styles.communicationHistoryTable}`}
          data-testid="application-notes-tab-sms-history-table"
        >
          <thead>
            <tr>
              <th>TO</th>
              <th>Message</th>
              <th>Status</th>
              <th>Date / Time</th>
            </tr>
          </thead>
          <tbody>
            {smsLogsList.length > 0 ? (
              smsLogsList.map((log: NoteLogRow, index: number) => (
                <tr key={log.id ?? log.sms_log_id ?? index}>
                  <td className={styles.historyLogToCell}>
                    <Mail
                      className={styles.historyLogIcon}
                      size={16}
                      aria-hidden
                    />
                    <span>{log.to || log.to_mobile || log.mobile_no || "N/A"}</span>
                  </td>
                  <td className={styles.historyLogMessageCell}>
                    {log.body || log.message || log.sms_type || "N/A"}
                  </td>
                  <td>{log.error_code ? "Undelivered" : "Delivered"}</td>
                  <td>{formatDateTime(log.sent_at || log.created_at)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className={styles.historyLogEmptyCell}>
                  No SMS history
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
